'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

var initialState = (0, _immutable.fromJS)({
  events: {},
  persons: {}
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var pathToEvents = ['events', action.stage_id];

  var pathToCurrentProperties = ['ui', action.feis_id];

  switch (action.type) {
    case 'GET_STAGES':
      return (0, _immutable.fromJS)(action.payload).reduce(function (state, stage) {
        return state.setIn(['one', stage.get('id')], stage);
      }, state);

    case 'GET_EVENTS_FOR_STAGE_START':
      return state.setIn(['loading', action.stage_id], true).setIn(['events', action.stage_id], (0, _immutable.List)()).setIn(['syncError'], false);

    case 'ATTACH_EVENT_TO_STAGE_START':
    case 'DETACH_EVENT_FROM_STAGE_START':
      return state.setIn(['loading', action.stage_id], true).setIn(['syncError'], false);

    case 'GET_EVENTS_FOR_STAGE':
      return state.setIn(pathToEvents, (0, _immutable.fromJS)(action.payload.events)).setIn(['loading', action.stage_id], false);

    case 'ATTACH_EVENT_TO_STAGE':
      {
        var stageId = action.stage_id;
        var beforeId = action.meta.before_id;
        var afterId = action.meta.after_id;

        var payload = action.payload.event || action.payload.placeholder && _extends({}, action.payload.placeholder, { placeholder: 1 }) || {};
        var event = (0, _immutable.fromJS)(payload);

        var events = state.getIn(pathToEvents, (0, _immutable.List)());

        var insertIndex = events.size;

        // matching logic in db query
        if (afterId) {
          var idx = events.findIndex(function (e) {
            return e.get('id') === afterId;
          });
          if (idx !== -1) insertIndex = idx;
        } else if (beforeId) {
          var _idx = events.findIndex(function (e) {
            return e.get('id') === beforeId;
          });
          if (_idx !== -1) insertIndex = _idx + 1;
        }

        var updatedEvents = events.slice(0, insertIndex).push(event).concat(events.slice(insertIndex));

        return state.setIn(pathToEvents, updatedEvents).setIn(['loading', stageId], false);
      }

    case 'DETACH_EVENT_FROM_STAGE':
      {
        var event_id = void 0;
        if (action.payload.event) {
          event_id = action.payload.event.id;
        } else {
          event_id = action.payload.placeholder_id;
        }
        var existingEvents = state.getIn(pathToEvents, (0, _immutable.List)());
        var _updatedEvents = existingEvents.filter(function (event) {
          return event.get('id') !== event_id;
        });

        return state.setIn(pathToEvents, _updatedEvents).setIn(['loading', action.stage_id], false);
      }

    case 'ATTACH_EVENT_TO_STAGE_ERROR':
    case 'DETACH_EVENT_FROM_STAGE_ERROR':
    case 'GET_EVENTS_FOR_STAGE_ERROR':
      {
        return state.setIn(['syncError'], true).setIn(['loading', action.stage_id], false);
      }

    case 'SPLIT_EVENT':
      return state.set('events', state.get('events').map(function (evs) {
        return evs.filter(function (e) {
          return e.get('id') !== action.event_id;
        });
      }));

    case 'MERGE_EVENT':
      var ev_a_id = action.ev_a_id,
          ev_b_id = action.ev_b_id;

      return state.set('events', state.get('events').map(function (evs) {
        return evs.filter(function (e) {
          return e.get('id') !== ev_a_id && e.get('id') !== ev_b_id;
        });
      }));

    case 'UPDATE_STAGE':
      return state.mergeIn(['one', action.payload.id], (0, _immutable.Map)({
        name: action.payload.name
      }));

    case 'CREATE_STAGE':
      return state.setIn(['one', action.payload.id], (0, _immutable.Map)({
        id: action.payload.id,
        name: action.payload.name,
        dt: action.payload.dt
      })).setIn(['events', action.payload.id], (0, _immutable.List)());

    case 'DELETE_STAGE':
      return state.deleteIn(pathToEvents).deleteIn(['one', action.stage_id]);

    case 'SET_CURRENT_STEWARDING_DATE':
      return state.setIn([].concat(pathToCurrentProperties, ['currentStewardingDay']), action.stewarding_day);

    case 'SET_CURRENT_STEWARDING_STAGE':
      return state.setIn([].concat(pathToCurrentProperties, ['currentStage']), action.stageId);

    case 'SET_PREVIOUS_STEWARDING_STAGE_PAGE_SOURCE':
      return state.setIn([].concat(pathToCurrentProperties, ['currentPageSource']), action.pageSource);

    case 'SET_CURRENT_STEWARDING_EVENT':
      return state.setIn([].concat(pathToCurrentProperties, ['currentEvent']), action.eventId);

    case 'SET_CURRENT_STEWARDING_PARTICIPANT':
      return state.setIn([].concat(pathToCurrentProperties, ['currentParticipant']), action.participantId);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/stages/index.js
// module id = 710
// module chunks = 0